// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayOutlinedSvg from "@fishx/icons-svg/es/asn/AlipayOutlined";
import FishxIcon from '../components/FishxIcon';

var AlipayOutlined = function AlipayOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayOutlinedSvg
  }));
};

AlipayOutlined.displayName = 'AlipayOutlined';
export default React.forwardRef(AlipayOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlipayOutlined.js
// module id = 1970
// module chunks = 0